export const API_ESTIMATION_LENGTH = '/api/estimator-seo/estimation-length'
export const API_NEW_QUERIES_POPULARITY = '/api/estimator-seo/new-queries-popularity'
export const API_ESTIMATION = '/api/estimator-seo/estimation'
